<template>
  <div class="table flex layout">
    <el-table
        :data="data"
        row-key="id"
        class="flex"
        height="100%"
        v-on="$listeners"
        :row-class-name="rowClassName"
        ref="table"
        @selection-change="handleSelectionChange"
    >
      <el-table-column
          v-if="isSelect"
          type="selection"
          :selectable="selectable"
          width="55"
      ></el-table-column>
      <el-table-column width="35" v-if="warning">
        <template slot-scope="scope" v-if="warning(scope.row)">
          <div style="text-align: center">
<!--            <img src="@/assets/img/warning.svg"/>-->
          </div>
        </template>
      </el-table-column>
      <el-table-column type="index" label="序号" v-if="isShowNumber"></el-table-column>
      <el-table-column v-for="item in columns" :key="item.label" v-bind="item">
        <template slot-scope="scope">
          <router-link
              v-if="item.url && item.auth"
              :to="item.url(scope.row)"
              class="ell"
              :title="scope.row[item.prop]"
              @click="item.isClick ? clickColums(scope.row) : ''"
              :class="{ canClick: item.isClick }"
          >{{ scope.row[item.prop] }}
          </router-link>
          <div
              v-else-if="item.isIconShow === 'true'"
              class="ell"
              :title="scope.row[item.prop]"
              @click="item.isClick ? clickColums(scope.row) : ''"
              :class="{ canClick: item.isClick }"
              style="display:flex"
          >
            <div v-if="scope.row[item.compareField] == '2'" class="stay-marker"></div>
            <div v-else-if="scope.row[item.compareField] == '3'" class="agree-marker"></div>
            <div v-else-if="scope.row[item.compareField] == '4'" class="refuse-marker"></div>
            <span v-if="scope.row[item.compareField] === '3'" style="color:#FF6A6A">{{ scope.row[item.prop] }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </div>
          <span
              v-else-if="item.prop === 'skuCount'"
              class="cell"
              :title="scope.row[item.prop]"
              @click="scope.row[item.prop] ? clickColums(scope.row) : ''"
          >{{ scope.row[item.prop] ? scope.row[item.prop] + '个型号' : '无' }}
          </span>
          <span
              v-else-if='typeof item.render === "function"'
              class="ell"
              :title="scope.row[item.prop]"
          ><span v-html="item.render( scope)"></span>
          </span>
          <span
              v-else
              class="ell"
              :title="scope.row[item.prop]"
              @click="item.isClick ? clickColums(scope.row) : ''"
              :class="{ canClick: item.isClick }"
          >{{ scope.row[item.prop] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="状态"
          v-if="$scopedSlots.state"
      >
        <template slot-scope="scope">
          <slot name="state" :row="scope.row"></slot>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          v-if="$scopedSlots.operate"
          :width="operateWidth"
      >
        <template slot-scope="scope">
          <slot name="operate" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <div class="page flex-none" v-if="pages">
      <el-pagination
              layout="prev, pager, next,total"
          background
          v-bind="pages"
          @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import CacheService from "@/service/catch";

export default {
  props: {
    columns: {
      default: () => [],
    },
    isSelect: {
      default: () => false,
    },
    isShowNumber:{
      default: () => true,
    },
    data: {
      default: () => [],
    },
    pages: {
      default: () => ({
        total: 0,
        "page-size": 10,
      }),
    },
    rowClassName: {
      default: "",
    },
    operateWidth: {
      default: "",
    },
    warning: {
      default: () => {
      },
    },
    loading: {
      default: false,
    },
    highlightCurrentRow: {
      default: false,
    },
    noCheck: {
      default: 0,
    }
  },
  mounted() {
    // console.log(this.$slots, this.$scopedSlots);
  },
  methods: {
     toggleRowSelection(row){
        this.$refs.table.toggleRowSelection(row)
    },
    clearSelection(){
        this.$refs.table.clearSelection()
    },
    currentChange(val) {
      this.$emit("currentChange", val);
    },
    handleSelectionChange(data) {
      this.$emit("selectionChange", data);
    },
    getTable() {
      return this.$refs.table;
    },
    clickColums(item) {
      this.$emit("clickColums", item);
    },
    selectable(row) {
      if (row.typeName == "delivery") {
        if (row.deliveryType == 1) {
          return false;
        }
      }
      if (this.noCheck==1 && row.id == CacheService.get("user").userID) {
        return false
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  // width: 100%;
  flex: 1;
  flex-direction: column;
  border: 1px #d7d7d7 solid;

  /deep/ .el-table-column--selection .cell {
    padding-left: 10px;
  }

  .el-table {
    overflow: auto;
  }

  .ell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .cell {
    color: #1B9AEE;
    cursor: pointer;
  }

  .page {
    background: white;
    padding: 10px;
    text-align: right;
  }

  /deep/.el-table__empty-block{
    background-color: white;
  }
  /deep/.el-table__body-wrapper{
    overflow-y: auto;
  }
  /deep/.el-table tr{
    background-color: white;
  }



  .canClick {
    cursor: pointer;
    color: #108cee;
  }

  .index {
    position: relative;
    width: 30px;
    height: 30px;
    display: inline-block;
    text-align: center;
  }

  .stay-marker {
    width: 6px;
    height: 6px;
    border-radius: 100px;
    background: #1890FF;
    margin: 9px 4px 0 0;
  }

  .agree-marker {
    width: 6px;
    height: 6px;
    border-radius: 100px;
    background: #4EB21F;
    margin: 9px 4px 0 0;
  }

  .refuse-marker {
    width: 6px;
    height: 6px;
    border-radius: 100px;
    background: #FF6A6A;;
    margin: 9px 4px 0 0;
  }
}
</style>
